import React, { useState } from 'react';
import ReliableGoogleSignIn from './ReliableGoogleSignIn';

const LoginPage = ({ onLogin }) => {
  const [isSignup, setIsSignup] = useState(false);
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    password: '',
    confirmPassword: ''
  });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  // Generate unique user ID
  // const generateUserId = () => {
  //   const timestamp = Date.now();
  //   const random = Math.random().toString(36).substr(2, 9);
  //   return `user_${timestamp}_${random}`;
  // };

  // Save user data to text file (simulated)
  const saveUserToFile = (userData) => {
    const userEntry = `
// User ID: ${userData.id}
Username: ${userData.username}
Email: ${userData.email}
Login Method: ${userData.loginMethod}
Registration Date: ${new Date().toISOString()}
----------------------------------------
`;
    
    // In a real app, this would be sent to backend to save to file
    // For now, we'll simulate by storing in localStorage
    const existingUsers = localStorage.getItem('userDatabase') || '';
    localStorage.setItem('userDatabase', existingUsers + userEntry);
    
    console.log('User saved to database:', userEntry);
  };

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSignup = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    // Validation
    if (!formData.username || !formData.email || !formData.password || !formData.confirmPassword) {
      setError('Please fill in all fields');
      setIsLoading(false);
      return;
    }

    if (formData.password !== formData.confirmPassword) {
      setError('Passwords do not match');
      setIsLoading(false);
      return;
    }

    if (formData.password.length < 6) {
      setError('Password must be at least 6 characters long');
      setIsLoading(false);
      return;
    }

    // Simulate API call
    setTimeout(async () => {
      // const userId = generateUserId();
      const userData = {
        // id: userId,
        username: formData.username,
        email: formData.email,
        loginMethod: 'email',
        registrationDate: new Date().toISOString()
      };

      // Save to "database" (text file simulation)
      await saveUserToFile(userData);
      
      // Save to localStorage for session
      localStorage.setItem('user', JSON.stringify(userData));
      onLogin(formData.username);
      setIsLoading(false);
    }, 1000);
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    // Validation
    if (!formData.email || !formData.password) {
      setError('Please fill in all fields');
      setIsLoading(false);
      return;
    }

    // Simulate login verification
    setTimeout(() => {
      // For demo purposes, we'll create a user if they don't exist
      // const userId = generateUserId();
      const userData = {
        // id: userId,
        username: formData.username || 'User',
        email: formData.email,
        loginMethod: 'email',
        loginDate: new Date().toISOString()
      };

      // Save login record
      saveUserToFile(userData);
      
      // Save to localStorage for session
      localStorage.setItem('user', JSON.stringify(userData));
      onLogin(userData.username);
      setIsLoading(false);
    }, 1000);
  };



  const toggleMode = () => {
    setIsSignup(!isSignup);
    setError('');
    setFormData({
      username: '',
      email: '',
      password: '',
      confirmPassword: ''
    });
  };

  return (
    <div className="login-container">
      {/* Animated Background Elements */}
      <div className="animated-background" />

      {/* Robot background image */}
      <div className="robot-background" />

      {/* Floating particles */}
      <div className="floating-particles">
        {Array.from({ length: 20 }).map((_, i) => (
          <div
            key={i}
            className="particle"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              width: `${Math.random() * 4 + 2}px`,
              height: `${Math.random() * 4 + 2}px`,
              animationDelay: `${Math.random() * 20}s`,
              animationDuration: `${Math.random() * 10 + 10}s`
            }}
          />
        ))}
      </div>

      <div className="login-content">
        {/* Header */}
        <div className="login-header">
          <h1 className="login-title">
            Gradi.AI
          </h1>
          <p className="login-subtitle">
            Sign in with your Adda Education work account
          </p>
        </div>

        {/* Google Sign-In Only */}
        <div className="login-form-container">
          {/* Google Sign-In */}
          <div className="google-signin-section">
            <ReliableGoogleSignIn 
              onSignIn={(user) => onLogin(user.name)}
              onSignOut={() => {}}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
